/**
 * @desc 根据平台订单id获取订单详细信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderFacadeImpl.getDetailBySpOrderId.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/rpc/omsflow/getDetailBySpOrderId`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
